/** Same stable asset name CI uploads; `releases/latest/download` always serves the newest tag. */
const DEFAULT_DESKTOP_EXE_URL =
  "https://github.com/travisbracegirdle/dripwatch/releases/latest/download/Dripwatch_x64-setup.exe";

/**
 * Windows download link. Baked in at `npm run build`.
 * - Set `VITE_DESKTOP_DOWNLOAD_URL` to override the `.exe` URL.
 * - Production default: GitHub Releases (no paid object storage).
 */
export function getDesktopDownloadUrl(): string | undefined {
  const raw = import.meta.env.VITE_DESKTOP_DOWNLOAD_URL as string | undefined;
  const fromEnv = raw?.trim();
  if (fromEnv) return fromEnv;
  if (import.meta.env.PROD) {
    return DEFAULT_DESKTOP_EXE_URL;
  }
  return undefined;
}
